import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2693d2aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col card-main mb-12" }
const _hoisted_2 = { class: "flex flex-col" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row justify-between items-center border-b-2 pb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-2xl font-semibold" }, "Personal Information")
], -1))
const _hoisted_4 = { class: "w-full flex flex-row justify-between space-x-3 mt-6" }
const _hoisted_5 = { class: "w-1/2" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "my-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, [
    /*#__PURE__*/_createTextVNode("First name "),
    /*#__PURE__*/_createElementVNode("span", { class: "text-orange-400" }, "(Required)")
  ])
], -1))
const _hoisted_7 = { class: "w-1/2" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "my-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, [
    /*#__PURE__*/_createTextVNode("Last name "),
    /*#__PURE__*/_createElementVNode("span", { class: "text-orange-400" }, "(Required)")
  ])
], -1))
const _hoisted_9 = { class: "w-full flex flex-row justify-between space-x-3 mt-2" }
const _hoisted_10 = { class: "w-1/2" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "my-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, [
    /*#__PURE__*/_createTextVNode("Email "),
    /*#__PURE__*/_createElementVNode("span", { class: "text-orange-400" }, "(Required)")
  ])
], -1))
const _hoisted_12 = { class: "w-1/2" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "my-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, [
    /*#__PURE__*/_createTextVNode("Phone "),
    /*#__PURE__*/_createElementVNode("span", { class: "text-orange-400" }, "(Required)")
  ])
], -1))
const _hoisted_14 = { class: "w-full flex flex-row justify-between space-x-3 mt-2" }
const _hoisted_15 = { class: "w-full" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "my-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, "Address ")
], -1))
const _hoisted_17 = { class: "flex flex-col mt-8" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-2xl font-semibold border-b-2 pb-2" }, "Profile", -1))
const _hoisted_19 = { class: "w-full flex flex-row justify-between space-x-3 mt-2" }
const _hoisted_20 = { class: "w-full" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "my-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "Position")
], -1))
const _hoisted_22 = { class: "flex flex-col mt-4" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "my-1 font-medium" }, "Summary", -1))
const _hoisted_24 = { class: "w-full" }
const _hoisted_25 = { class: "mt-4" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-medium mr-2 border-b-2 pb-2" }, "Skills", -1))
const _hoisted_27 = { class: "my-5" }
const _hoisted_28 = { class: "mt-2" }
const _hoisted_29 = {
  key: 0,
  class: "py-2"
}
const _hoisted_30 = { class: "mt-2" }
const _hoisted_31 = { class: "py-2" }
const _hoisted_32 = { class: "mt-4 mb-3" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-medium mr-2 border-b-2 pb-2" }, [
  /*#__PURE__*/_createTextVNode(" Resume "),
  /*#__PURE__*/_createElementVNode("span", { class: "font-thin text-orange-400" }, "(Required)")
], -1))
const _hoisted_34 = { class: "w-full mt-3" }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = {
  key: 1,
  class: "mt-6"
}
const _hoisted_37 = { class: "flex flex-row justify-between items-center rounded-lg shadow-lg border border-gray-100 p-2" }
const _hoisted_38 = { class: "flex flex-row items-center" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "h-8 w-8 text-purple-500",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z" }),
  /*#__PURE__*/_createElementVNode("polyline", { points: "13 2 13 9 20 9" })
], -1))
const _hoisted_40 = { class: "flex flex-col ml-2" }
const _hoisted_41 = { class: "" }
const _hoisted_42 = { class: "uppercase font-thin text-gray-300 text-sm" }
const _hoisted_43 = { class: "flex flex-row justify-end" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("polyline", { points: "23 4 23 10 17 10" }, null, -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("polyline", { points: "1 20 1 14 7 14" }, null, -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" }, null, -1))
const _hoisted_47 = [
  _hoisted_44,
  _hoisted_45,
  _hoisted_46
]
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-medium mr-2 border-b-2 pb-2" }, "Other document", -1))
const _hoisted_49 = { key: 0 }
const _hoisted_50 = { class: "mt-4 mb-3" }
const _hoisted_51 = { class: "w-full mt-3" }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = {
  key: 1,
  class: "mt-6"
}
const _hoisted_54 = { class: "flex flex-row justify-between items-center rounded-lg shadow-lg border border-gray-100 p-2" }
const _hoisted_55 = { class: "flex flex-row items-center" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "h-8 w-8 text-purple-500",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z" }),
  /*#__PURE__*/_createElementVNode("polyline", { points: "13 2 13 9 20 9" })
], -1))
const _hoisted_57 = { class: "flex flex-col ml-2" }
const _hoisted_58 = { class: "" }
const _hoisted_59 = { class: "uppercase font-thin text-gray-300 text-sm" }
const _hoisted_60 = { class: "flex flex-row justify-end" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("polyline", { points: "23 4 23 10 17 10" }, null, -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("polyline", { points: "1 20 1 14 7 14" }, null, -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" }, null, -1))
const _hoisted_64 = [
  _hoisted_61,
  _hoisted_62,
  _hoisted_63
]
const _hoisted_65 = {
  key: 1,
  class: "mt-4 mb-3"
}
const _hoisted_66 = { class: "flex flex-col" }
const _hoisted_67 = { class: "h-64 relative rounded-2xl p-8 shadow input-file" }
const _hoisted_68 = ["onchange"]
const _hoisted_69 = /*#__PURE__*/_createStaticVNode("<div class=\"relative h-full w-full flex flex-col justify-center items-center animate__animated animate__fadeIn animate__delay-0.6s\" data-v-2693d2aa><svg class=\"h-14 w-14 text-primary mb-2\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-2693d2aa><polyline points=\"16 16 12 12 8 16\" data-v-2693d2aa></polyline><line x1=\"12\" y1=\"12\" x2=\"12\" y2=\"21\" data-v-2693d2aa></line><path d=\"M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3\" data-v-2693d2aa></path><polyline points=\"16 16 12 12 8 16\" data-v-2693d2aa></polyline></svg><span class=\"text-gray-500 font-medium text-base\" data-v-2693d2aa>Drag your files here</span><span class=\"text-gray-500 font-mediu\" data-v-2693d2aa>OR</span><span class=\"bg-primary text-white px-5 py-3 rounded-3xl cursor-pointer font-medium\" data-v-2693d2aa>Browse file</span></div>", 1)
const _hoisted_70 = {
  key: 0,
  class: "w-full mt-2 p-2"
}
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500 font-semibold pb-2 border-b-2 w-full" }, " Files uploaded ", -1))
const _hoisted_72 = { class: "flex flex-row justify-between items-center space-y-3 p-2" }
const _hoisted_73 = { class: "mr-2" }
const _hoisted_74 = ["src"]
const _hoisted_75 = { class: "flex flex-col w-full" }
const _hoisted_76 = { class: "text-sm text-gray-600 font-medium" }
const _hoisted_77 = { class: "text-xs uppercase text-gray-500 leading-4" }
const _hoisted_78 = { class: "flex flex-row space-x-3" }
const _hoisted_79 = ["onClick"]
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "h-6 w-6 text-red-500",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
  })
], -1))
const _hoisted_81 = [
  _hoisted_80
]
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "h-6 w-6 text-green-500",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, [
    /*#__PURE__*/_createElementVNode("polyline", { points: "20 6 9 17 4 12" })
  ])
], -1))
const _hoisted_83 = { class: "flex flex-row justify-between items-center space-y-3 p-2" }
const _hoisted_84 = { class: "mr-2" }
const _hoisted_85 = ["src"]
const _hoisted_86 = { class: "flex flex-col w-full" }
const _hoisted_87 = { class: "text-sm text-gray-600 font-medium" }
const _hoisted_88 = { class: "text-xs uppercase text-gray-500 leading-4" }
const _hoisted_89 = { class: "flex flex-row space-x-3" }
const _hoisted_90 = ["onClick"]
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "h-6 w-6 text-red-500",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
  })
], -1))
const _hoisted_92 = [
  _hoisted_91
]
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "h-6 w-6 text-green-500",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, [
    /*#__PURE__*/_createElementVNode("polyline", { points: "20 6 9 17 4 12" })
  ])
], -1))
const _hoisted_94 = { class: "w-full flex flex-row justify-between space-x-3 mt-2" }
const _hoisted_95 = { class: "w-full" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "my-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "Link")
], -1))
const _hoisted_97 = { class: "flex flex-col mt-8" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-2xl font-semibold border-b-2 pb-2" }, "Preferences", -1))
const _hoisted_99 = { class: "mt-5 flex flex-row justify-end items-center" }
const _hoisted_100 = { class: "mt-3" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "my-2 font-medium" }, "Expected salary")
], -1))
const _hoisted_102 = { class: "flex flex-col lg:flex-row justify-between items-center lg:space-x-12 space-y-3 lg:space-y-0" }
const _hoisted_103 = { class: "w-full" }
const _hoisted_104 = { class: "w-full" }
const _hoisted_105 = { class: "mt-3" }
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "my-2 font-medium" }, "Current salary")
], -1))
const _hoisted_107 = { class: "flex flex-col lg:flex-row justify-between items-center lg:space-x-12 space-y-3 lg:space-y-0" }
const _hoisted_108 = { class: "w-full" }
const _hoisted_109 = { class: "w-full" }
const _hoisted_110 = {
  key: 0,
  class: "p-3 bg-primary-light mt-4 rounded text-primary animate__animated animate__fadeIn"
}
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Note:"),
  /*#__PURE__*/_createTextVNode(" The anual salary will be displayed as:")
], -1))
const _hoisted_112 = { class: "mt-2 ml-4 flex flex-col space-y-1" }
const _hoisted_113 = {
  key: 0,
  class: "text-primary font-medium"
}
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-primary" }, "Expected salary:", -1))
const _hoisted_115 = {
  key: 1,
  class: "text-primary font-medium"
}
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-primary" }, "Current salary:", -1))
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-t-2 border-gray-200 w-full mt-8" }, null, -1))
const _hoisted_118 = { class: "mt-6" }
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "my-2 font-medium" }, "Preferred work type")
], -1))
const _hoisted_120 = { class: "flex flex-row justify-between" }
const _hoisted_121 = { class: "flex flex-row justify-end mt-12" }
const _hoisted_122 = { class: "flex flex-row justify-between items-center space-x-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextField = _resolveComponent("TextField")!
  const _component_AutocompleteLocation = _resolveComponent("AutocompleteLocation")!
  const _component_TextArea = _resolveComponent("TextArea")!
  const _component_Chips = _resolveComponent("Chips")!
  const _component_WorkExperienceArrayField = _resolveComponent("WorkExperienceArrayField")!
  const _component_EducationArrayField = _resolveComponent("EducationArrayField")!
  const _component_DragAndDropFile = _resolveComponent("DragAndDropFile")!
  const _component_CheckBox = _resolveComponent("CheckBox")!
  const _component_CurrencyField = _resolveComponent("CurrencyField")!
  const _component_DropDown = _resolveComponent("DropDown")!
  const _component_CheckBoxGroup = _resolveComponent("CheckBoxGroup")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("form", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_TextField, {
                label: "",
                placeholder: "First name",
                typeInput: "text",
                name: "first_name",
                floatingInput: true
              })
            ]),
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_TextField, {
                label: "",
                placeholder: "Last name",
                typeInput: "text",
                name: "last_name",
                floatingInput: true
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode(_component_TextField, {
                label: "",
                placeholder: "Email",
                typeInput: "mail",
                name: "email",
                floatingInput: true
              })
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode(_component_TextField, {
                label: "",
                placeholder: "Phone number",
                typeInput: "text",
                name: "phone",
                floatingInput: true
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createVNode(_component_AutocompleteLocation, {
                "onUpdate:modelValue": _ctx.updateHandler,
                locationName: _ctx.locationName
              }, null, 8, ["onUpdate:modelValue", "locationName"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createVNode(_component_TextField, {
                label: "",
                placeholder: "Position",
                typeInput: "text",
                name: "position",
                floatingInput: true
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createElementVNode("div", _hoisted_24, [
              _createVNode(_component_TextArea, {
                modelValue: _ctx.summary,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.summary) = $event)),
                label: "Write here",
                rows: "4",
                className: "pt-5 pb-2 pl-4 pr-10 block w-full px-0 mt-0 bg-transparent border-2 rounded-lg border-solid appearance-none focus:outline-none focus:ring-0 focus:border-gray-200 border-gray-200",
                isLabel: false,
                placeholder: "Write here",
                name: "summary"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createElementVNode("div", _hoisted_27, [
              _createVNode(_component_Chips, {
                chips: _ctx.skills,
                placeholder: "Add skill"
              }, null, 8, ["chips"])
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            (_ctx.industries)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _createVNode(_component_WorkExperienceArrayField, { industries: _ctx.industries }, null, 8, ["industries"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_component_EducationArrayField)
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_32, [
              _hoisted_33,
              _createElementVNode("div", _hoisted_34, [
                (!_ctx.cvFileAux)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                      _createVNode(_component_DragAndDropFile, {
                        modelValue: _ctx.cvFile,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.cvFile) = $event)),
                        placeholder: "You can upload PDF or DOC/XLS. The maxmimum file size of file is 5MB.",
                        label: "Drag and drop your file here",
                        fileTypes: ".doc,.docx,application/msword,application/vnd.ms-excel,application/pdf"
                      }, null, 8, ["modelValue"])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          _hoisted_39,
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.getFileName(_ctx.cvFileAux)), 1),
                            _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.getFileExtension(_ctx.cvFileAux)), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_43, [
                          (_openBlock(), _createElementBlock("svg", {
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.cvFileAux = null)),
                            class: "h-6 w-6 text-purple-500 mr-3",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          }, _hoisted_47))
                        ])
                      ])
                    ]))
              ])
            ])
          ]),
          _hoisted_48,
          (
              _ctx.typeForm === 'createCandidate' || _ctx.typeForm === 'editCandidate'
            )
            ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    (!_ctx.otherFileAux)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                          _createVNode(_component_DragAndDropFile, {
                            modelValue: _ctx.otherFile,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.otherFile) = $event)),
                            placeholder: "You can upload PDF or DOC/XLS. The maxmimum file size of file is 5MB.",
                            label: "Drag and drop your file here",
                            fileTypes: ".doc,.docx,application/msword,application/vnd.ms-excel,application/pdf"
                          }, null, 8, ["modelValue"])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_53, [
                          _createElementVNode("div", _hoisted_54, [
                            _createElementVNode("div", _hoisted_55, [
                              _hoisted_56,
                              _createElementVNode("div", _hoisted_57, [
                                _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.getFileName(_ctx.otherFileAux)), 1),
                                _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.getFileExtension(_ctx.otherFileAux)), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_60, [
                              (_openBlock(), _createElementBlock("svg", {
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.otherFileAux = null)),
                                class: "h-6 w-6 text-purple-500 mr-3",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              }, _hoisted_64))
                            ])
                          ])
                        ]))
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_65, [
                _createElementVNode("div", _hoisted_66, [
                  _createElementVNode("div", _hoisted_67, [
                    _createElementVNode("input", {
                      class: "opacity-0 z-20 absolute w-full top-0 bottom-0 -ml-8 appearance-none cursor-pointer",
                      name: "file",
                      id: "entry_value",
                      ref: "fileInput",
                      type: "file",
                      accept: ".jpg, .jpeg, .png, .pdf, .xlsx, .xls, .doc, .docx, .odt",
                      onchange: _ctx.addFile
                    }, null, 8, _hoisted_68),
                    _hoisted_69
                  ])
                ]),
                (_ctx.files.length > 0 || _ctx.candidateDocuments.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                      _hoisted_71,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.candidateDocuments, (file, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "stripe px-2 mt-2",
                          key: index
                        }, [
                          _createElementVNode("div", _hoisted_72, [
                            _createElementVNode("div", _hoisted_73, [
                              _createElementVNode("img", {
                                src: _ctx.getFileIcon(_ctx.getFileExtension(file.document.url)),
                                alt: ""
                              }, null, 8, _hoisted_74)
                            ]),
                            _createElementVNode("div", _hoisted_75, [
                              _createElementVNode("span", _hoisted_76, _toDisplayString(_ctx.getFileName(file.document.url)), 1),
                              _createElementVNode("span", _hoisted_77, _toDisplayString(_ctx.getFileExtension(file.document.url)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_78, [
                              _createElementVNode("span", {
                                onClick: ($event: any) => (_ctx.deleteServerFile(file.id)),
                                class: "cursor-pointer"
                              }, _hoisted_81, 8, _hoisted_79),
                              _hoisted_82
                            ])
                          ])
                        ]))
                      }), 128)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (file, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "stripe px-2 mt-2",
                          key: index
                        }, [
                          _createElementVNode("div", _hoisted_83, [
                            _createElementVNode("div", _hoisted_84, [
                              _createElementVNode("img", {
                                src: _ctx.getFileIcon(_ctx.getFileExtension(file.name)),
                                alt: ""
                              }, null, 8, _hoisted_85)
                            ]),
                            _createElementVNode("div", _hoisted_86, [
                              _createElementVNode("span", _hoisted_87, _toDisplayString(file.name), 1),
                              _createElementVNode("span", _hoisted_88, _toDisplayString(_ctx.getFileExtension(file.name)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_89, [
                              _createElementVNode("span", {
                                onClick: ($event: any) => (_ctx.deleteFile(index)),
                                class: "cursor-pointer"
                              }, _hoisted_92, 8, _hoisted_90),
                              _hoisted_93
                            ])
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ])),
          _createElementVNode("div", _hoisted_94, [
            _createElementVNode("div", _hoisted_95, [
              _hoisted_96,
              _createVNode(_component_TextField, {
                label: "",
                placeholder: "Link",
                typeInput: "text",
                name: "link",
                floatingInput: true
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_97, [
          _hoisted_98,
          _createElementVNode("div", _hoisted_99, [
            _createVNode(_component_CheckBox, {
              label: "Show monthly salary",
              fieldId: "salaryMonthly",
              textSize: "font-semibold ",
              checked: _ctx.salaryMonthly,
              "onUpdate:checked": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.salaryMonthly) = $event))
            }, null, 8, ["checked"])
          ]),
          _createElementVNode("div", _hoisted_100, [
            _hoisted_101,
            _createElementVNode("div", _hoisted_102, [
              _createElementVNode("div", _hoisted_103, [
                _createVNode(_component_CurrencyField, {
                  modelValue: _ctx.salaryExpectation,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.salaryExpectation) = $event)),
                  label: "Salary per year",
                  name: "salary_expectation"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_104, [
                _createVNode(_component_DropDown, {
                  modelValue: _ctx.salaryCurrency,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.salaryCurrency) = $event)),
                  options: _ctx.optionCurrencies,
                  label: "Select currency...",
                  name: "salary_currency"
                }, null, 8, ["modelValue", "options"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_105, [
            _hoisted_106,
            _createElementVNode("div", _hoisted_107, [
              _createElementVNode("div", _hoisted_108, [
                _createVNode(_component_CurrencyField, {
                  modelValue: _ctx.currentSalary,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.currentSalary) = $event)),
                  label: "Salary per year",
                  name: "current_salary"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_109, [
                _createVNode(_component_DropDown, {
                  modelValue: _ctx.currentSalaryCurrency,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.currentSalaryCurrency) = $event)),
                  options: _ctx.optionCurrencies,
                  label: "Select currency...",
                  name: "current_salary_currency"
                }, null, 8, ["modelValue", "options"])
              ])
            ])
          ]),
          (_ctx.salaryMonthly && (_ctx.salaryExpectation > 0 || _ctx.currentSalary > 0))
            ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                _hoisted_111,
                _createElementVNode("div", _hoisted_112, [
                  (_ctx.salaryExpectation > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_113, [
                        _hoisted_114,
                        _createTextVNode(" $" + _toDisplayString(_ctx.numberFormattedWithCommas(Number(_ctx.salaryExpectation / 12))) + " " + _toDisplayString(_ctx.salaryCurrency) + " Monthly", 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.currentSalary > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_115, [
                        _hoisted_116,
                        _createTextVNode(" $" + _toDisplayString(_ctx.numberFormattedWithCommas(Number(_ctx.currentSalary / 12))) + " " + _toDisplayString(_ctx.currentSalaryCurrency) + " Monthly", 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          _hoisted_117,
          _createElementVNode("div", _hoisted_118, [
            _hoisted_119,
            _createElementVNode("div", _hoisted_120, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workTypes, (item, index) => {
                return (_openBlock(), _createBlock(_component_CheckBoxGroup, {
                  key: `work-type${index}`,
                  fieldId: item.label,
                  names: _ctx.preferred_work_types,
                  "onUpdate:names": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.preferred_work_types) = $event)),
                  label: item.label,
                  value: item.value
                }, null, 8, ["fieldId", "names", "label", "value"]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_121, [
          _createElementVNode("div", _hoisted_122, [
            _createVNode(_component_Button, {
              variant: "outlined",
              label: "Cancel",
              onClick: _ctx.onCancelButton
            }, null, 8, ["onClick"]),
            _createVNode(_component_Button, {
              variant: "contained",
              label: _ctx.isLoadingButton ? _ctx.textButtonSaving : _ctx.textButton,
              onClick: _ctx.onSubmit,
              disabled: !_ctx.validForm || _ctx.isLoadingButton
            }, null, 8, ["label", "onClick", "disabled"])
          ])
        ])
      ])
    ])
  ]))
}